'use client';

import Image from 'next/image';
import { Fragment } from 'react';
import clsx from 'clsx';

import {
  Breadcrumb as BreadcrumbBase,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/slw/shared/ui/breadcrumb';

export function Breadcrumb({ data }: { data: { name: string; href?: string }[] }) {
  return (
    <BreadcrumbBase className='my-8'>
      <BreadcrumbList className='flex items-center'>
        <BreadcrumbItem>
          <BreadcrumbLink className='flex items-center gap-2' href='/'>
            <Image src='/images/common/home-icon.png' width={22} height={22} alt='' />
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        {data.map((item, idx) => (
          <Fragment key={idx}>
            <BreadcrumbSeparator>
              <span>/</span>
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbPage
                className={clsx({
                  'text-primary': idx === data.length - 1,
                })}
              >
                {item.href ? (
                  <BreadcrumbLink className='flex items-center gap-2' href={item.href}>
                    {item.name}
                  </BreadcrumbLink>
                ) : (
                  item.name
                )}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </BreadcrumbBase>
  );
}
